import React from 'react';
import PropTypes from 'prop-types';

export default function ArrowLeft(props) {
  return (
    <svg width={props.width} height={props.width} viewBox="0 0 24 24" fill="none" stroke={props.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
  );
}

ArrowLeft.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

ArrowLeft.defaultProps = {
  color: '#202020',
  width: 20,
};